import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {DynamicDictionary} from "../../../shared/interface/dynamic-dictionary";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {UserService} from "../../../shared/services/user.service";
import {DynamicDictService} from "../../../shared/services/dynamic-dict.service";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-dynamic-dictionary-add',
  templateUrl: './dynamic-dictionary-add.component.html',
  styleUrls: ['./dynamic-dictionary-add.component.scss']
})
export class DynamicDictionaryAddComponent implements OnInit,  OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() dynamicDictionary?: DynamicDictionary;
  @Input() mod = false;
  @Output() closeModification = new EventEmitter<any>();
  @ViewChild('imageSelect') imageSelect: ElementRef;

  dynamicDictionaryForm: FormGroup;
  typeControl: FormControl;
  nameControl: FormControl;
  errors: any = {};
  userPermissions: ReplaySubject<UserPermissions>;
  dictFormValid = false;
  processingRequest = false;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private dynamicDictService: DynamicDictService,
    private auth: AuthService,
    private userService: UserService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.dynamicDictionaryForm = fb.group({
      id: this.fb.control('', []),
      name: this.nameControl = this.fb.control('', [Validators.required]),
      type: this.typeControl = this.fb.control('', [Validators.required]),

    });
  }

  ngOnInit(): void {
    this.dynamicDictionaryForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.dictFormValid = this.dynamicDictionaryForm.valid);
  }

  ngAfterViewInit(): void {
    if (this.dynamicDictionary) {
      this.initialize(this.dynamicDictionary);
    } else {
      this.initialized.next(true);
    }
  }

  initialize(dynamicDictionary: DynamicDictionary): void {
    of(dynamicDictionary)
      .pipe(
        delay(0),
        tap(() => {
          this.dynamicDictionaryForm.reset({
            id: dynamicDictionary.id,
            name: dynamicDictionary.name,
            type: dynamicDictionary.type.id,
          });

        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (!this.dynamicDictionary) {
      this.router.navigate(['/dynamiczny-slownik']);
    } else {
      this.closeModification.emit();
    }

  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.dynamicDictionaryForm, this.errors);
    this.errors = {};
    this.dynamicDictService.sendForm(this.dynamicDictionaryForm.value, this.dynamicDictionary ? this.dynamicDictionary.id.toString() : null  )
      .subscribe(() => {
        this.snack.open(this.dynamicDictionary ? 'Pomyślnie zaktualizowano słownik' : 'Pomyślnie dodano wartość do słownika', '', {
          duration: 2000,
        });
        this.closeModification.emit();
        if (!this.dynamicDictionary) {
          this.router.navigate(['/dynamiczny-slownik']);
        }
        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.dynamicDictionaryForm, this.errors);
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open('Podczas dodawania wartość do słownika wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      });
  }

}
